// extracted by mini-css-extract-plugin
export default {"container":"team-selector_container__3o5mT"};